/**
 *
 *
 *
 *
 */

import {
  endBenchmark,
  startBenchmark,
  updateBenchmarkEnabled,
} from "../observability/benchmark";
import { userConsentsAccepted } from "../consent/otto";
import {
  cacheUserData,
  exactagData,
  removeEmptyItems,
} from "./data";
import { toggleTestMode } from "../observability/testFlags";
import { addCampaignId, updatePartnerConsents } from "../consent/partner";
import { exactagScope, exactagState, seleniumBypassAdvertising } from "./utils";
import { addVerticalsData } from "../collect/verticals";
import {
  eprivacyConsent,
  getUserConsentForGV,
  updateConsent,
} from "../consent/otto";
import { appendVarnishData } from "../collect/varnish";
import { addElchCookieData } from "../collect/pminfo";
import { addGenericData } from "../collect/generic";
import type { ExactagData } from "./core.types";

const log = exactagScope.scope("core.execute");

/**
 *
 *
 *
 */
export function executeExactagProcess(): void {
  /*                                              */
  if (!exactagState.centralComplete) {
    log.info("Exactag not ready yet, abort", exactagState);
    return;
  }

  /*                               */
  exactagData.cb = userConsentsAccepted() ? "1" : "0";

  appendVarnishData();

  removeEmptyItems();

  toggleTestMode();

  /*                                                  */
  if (seleniumBypassAdvertising() && userConsentsAccepted()) {
    window.exactag.track({ ...exactagData }); /*             */
    log.info("Exactag started with", exactagData);
    endBenchmark();
    /*                                                                 */
    cacheUserData();

    return;
  }

  log.debug("Exactag not started with", exactagData);
}

/**
 *
 *
 *
 *
 *
 *
 */
export function submitToExactag(
  newData: ExactagData,
  data = exactagData
): ExactagData {
  Object.assign(data, newData);
  executeExactagProcess();
  return data;
}

/**
 *
 */
export async function initializeExactag(): Promise<void> {
  updateBenchmarkEnabled();
  startBenchmark();
  addCampaignId();
  addGenericData();
  addElchCookieData();
  await addVerticalsData();

  await updatePartnerConsents();

  log.info("Exactag initialized", exactagState);
  exactagState.centralComplete = true;

  /*                                                                   */
  /*                   */
  executeExactagProcess();
}

/**
 *
 *
 *
 *
 */
export const executeExactagHandler = async (): Promise<void> => {
  log.info("Execute exactag handler for event");

  await updatePartnerConsents();

  const userConsent = await getUserConsentForGV();
  if (!updateConsent(eprivacyConsent, userConsent)) return;

  log.info("Execute exactag", exactagState);
  executeExactagProcess();
};
